$(document).ready(function() {
    var $form = $('.trial-signup');

    if(!$form.length) {
        return false;
    }

    bindForm($form);
});